import React from 'react';
import ParticleCanvas from './ParticleCanvas';
import { TwitchIcon, YouTubeIcon, InstagramIcon, DiscordIcon } from '../icons/SocialIcons';
import {
  DISCORD_URL,
  INSTAGRAM_URL,
  TWITCH_URL,
  YOUTUBE_ASMR_URL,
  YOUTUBE_CERAMICA_URL,
} from '../../constants/social';

const twitchChannel = process.env.REACT_APP_TWITCH_CHANNEL || TWITCH_URL;

export default function Hero() {
  return (
    <section className="relative min-h-screen flex flex-col items-center justify-center overflow-hidden bg-gradient-to-b from-[#0d0a1a] via-[#120e22] to-[#0a0815]">
      <ParticleCanvas />

      <div className="absolute top-1/4 left-1/4 w-96 h-96 rounded-full bg-rose-400/15 blur-3xl pointer-events-none" />
      <div className="absolute bottom-1/4 right-1/4 w-96 h-96 rounded-full bg-sky-400/15 blur-3xl pointer-events-none" />
      <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[500px] h-[500px] rounded-full bg-violet-400/10 blur-[100px] pointer-events-none" />

      <div className="relative z-10 flex flex-col items-center text-center px-6 max-w-4xl mx-auto pt-24 pb-16">
        <div className="mb-6 inline-flex items-center gap-2 px-4 py-2 rounded-full border border-rose-300/25 bg-rose-300/10 backdrop-blur-sm">
          <span className="w-2 h-2 rounded-full bg-rose-400 animate-pulse" />
          <span className="text-rose-200 text-sm font-medium tracking-wider uppercase">Lun — Jue · 22:30 hs · Vie · Cowork al mediodía (ARG)</span>
        </div>

        <h1 className="font-bold tracking-tight leading-none mb-4">
          <span className="block text-6xl sm:text-8xl text-transparent bg-clip-text bg-gradient-to-br from-rose-300 via-pink-200 to-sky-300">
            EuGe_NiAL
          </span>
        </h1>

        <p className="text-xl sm:text-2xl text-slate-300 font-medium tracking-wide mb-3">
          Streamer de ASMR · Argentina
        </p>

        <p className="text-base text-slate-400 max-w-xl leading-relaxed mb-8">
          Un espacio de calma, relajación y amor. Cada directo es un refugio tranquilo donde la comunidad
          de los <span className="text-rose-300 font-semibold">Eugenialitos</span> se reúne a descansar y compartir.
        </p>

        <div className="flex flex-wrap justify-center gap-3 mb-10">
          <SocialButton href={twitchChannel} label="Twitch · EuGe_NiAL" icon={<TwitchIcon className="w-5 h-5" />} bg="bg-[#9146ff]/80" hover="hover:bg-[#9146ff]" text="text-white" />
          <SocialButton href={YOUTUBE_CERAMICA_URL} label="YouTube · CeramiCalmaASMR" icon={<YouTubeIcon className="w-5 h-5" />} bg="bg-[#ff5555]/80" hover="hover:bg-[#ff5555]" text="text-white" />
          <SocialButton href={YOUTUBE_ASMR_URL} label="YouTube · EugenialASMR" icon={<YouTubeIcon className="w-5 h-5" />} bg="bg-[#ff5555]/80" hover="hover:bg-[#ff5555]" text="text-white" />
          <SocialButton href={INSTAGRAM_URL} label="Instagram" icon={<InstagramIcon className="w-5 h-5" />} bg="bg-gradient-to-tr from-[#feda75]/80 via-[#d62976]/80 to-[#962fbf]/80" hover="hover:opacity-100 opacity-90" text="text-white" />
          <SocialButton href={DISCORD_URL} label="Discord" icon={<DiscordIcon className="w-5 h-5" />} bg="bg-[#5865f2]/80" hover="hover:bg-[#5865f2]" text="text-white" />
        </div>

        <div className="mt-8 flex flex-col items-center gap-2 text-slate-500 text-xs tracking-widest uppercase">
          <span>Explorar</span>
          <div className="w-px h-8 bg-gradient-to-b from-slate-400 to-transparent animate-pulse" />
        </div>
      </div>
    </section>
  );
}

function SocialButton({
  href,
  label,
  icon,
  bg,
  hover,
  text,
}: {
  href: string;
  label: string;
  icon: React.ReactNode;
  bg: string;
  hover: string;
  text: string;
}) {
  return (
    <a
      href={href}
      target="_blank"
      rel="noopener noreferrer"
      className={`group inline-flex items-center gap-2.5 px-5 py-3 rounded-2xl ${bg} ${hover} ${text} font-medium text-sm shadow-lg shadow-black/20 transition-all duration-300 hover:-translate-y-0.5 hover:shadow-xl`}
    >
      <span className="group-hover:scale-110 transition-transform">{icon}</span>
      {label}
    </a>
  );
}
